import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import ResetPasswordForm from './ResetPasswordForm';
import Header from '../../shared/Header';

import { resetPassword } from './redux/actions';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-color: #2a425e;
  display: flex;
  justify-content: center;
`;

class ResetPassword extends Component {
  state = {
    token: '',
  };
  componentDidMount() {
    let queryParams = this.parseQuery(this.props.location.search);
    if (queryParams.token) {
      this.setState({ token: queryParams.token }, () => {
        localStorage.setItem('authorization', queryParams.token);
      });
    }
  }

  parseQuery = searchQuery => {
    const query = searchQuery.split('?')[1];
    let queryParams = {};
    if (query) {
      let params = query.split('&');
      params.forEach(value => {
        if (value.includes('=')) {
          const param = value.split('=');
          queryParams[param[0]] = param[1];
        }
      });
    }
    return queryParams;
  };

  render() {
    const { token } = this.state;
    if (token) {
      return (
        <Wrapper>
          <Header type="login" />
          <ResetPasswordForm
            resetPassword={this.props.resetPassword}
            history={this.props.history}
            token={token}
          />
        </Wrapper>
      );
    } else {
      return null;
    }
  }
}

export default connect(
  null,
  { resetPassword }
)(ResetPassword);



// WEBPACK FOOTER //
// ./src/components/screens/ResetPassword/ResetPassword.jsx